/**
 * Application Constants
 * Centralized configuration and constant values
 */

// Product Types
export const PRODUCTS = {
  CANDY: 'candy',
  APPAREL: 'apparel'
};

export const PRODUCT_NAMES = {
  [PRODUCTS.CANDY]: 'Performance Candies',
  [PRODUCTS.APPAREL]: 'Athletic Clothing'
};

export const PRODUCT_DESCRIPTIONS = {
  [PRODUCTS.CANDY]: 'High-energy performance candies designed for athletes',
  [PRODUCTS.APPAREL]: 'Premium athletic wear for peak performance'
};

// API Configuration
export const API = {
  BASE_URL: 'http://localhost:5001/api',
  TIMEOUT: 10000
};

// UI Constants
export const ANIMATION = {
  FADE_IN_DURATION: 300,
  SLIDE_UP_DURATION: 200,
  AUTO_HIDE_DURATION: 3000
};

export const VALIDATION = {
  EMAIL_REGEX: /^\w+([-.]?\w+)*@\w+([-.]?\w+)*(\.\w{2,3})+$/,
  MIN_PASSWORD_LENGTH: 8,
  MAX_EMAIL_LENGTH: 254
};

// Error Messages
export const ERROR_MESSAGES = {
  NETWORK_ERROR: 'Network error. Please check your connection.',
  SERVER_ERROR: 'Server error. Please try again later.',
  INVALID_EMAIL: 'Please enter a valid email address.',
  EMAIL_REQUIRED: 'Email is required.',
  PRODUCT_REQUIRED: 'Product is required.',
  DUPLICATE_SIGNUP: 'This email is already subscribed.',
  DUPLICATE_CLICK: 'You have already clicked this button.',
  FORM_SUBMISSION_FAILED: 'Failed to submit form. Please try again.'
};

// Success Messages
export const SUCCESS_MESSAGES = {
  SIGNUP_SUCCESS: 'Successfully signed up for notifications!',
  CLICK_TRACKED: 'Thank you for your interest!'
};

// Storage Keys
export const STORAGE_KEYS = {
  USER_PREFERENCES: 'sambas_user_preferences',
  CLICKED_PRODUCTS: 'sambas_clicked_products',
  SIGNUP_EMAIL: 'sambas_signup_email'
};

// Routes
export const ROUTES = {
  HOME: '/',
  CANDY: '/candy',
  APPAREL: '/apparel'
};
